import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { NotifimodalPage } from '../notifimodal/notifimodal';
import { LoginPage } from '../login/login';

/**
 * Generated class for the NotificationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-notification',
	templateUrl: 'notification.html',
})
export class NotificationPage {

	list: any[];
    items: any[] = [];
    count_list: number = 0;
    max_list: number = 0;
	

	loginId: string;
	api_key: string;
	version: string;
	noti_title: string;
	noti_date: string;

	texts: any = [];
	language: string;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
		private http: HttpService,
		public app: App
	) {
		
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "notification");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");

		this._init();
		
		this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).notification;
	}

	_init() {
		
		this.list = [];

		let url = "info/notice/index/list";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				if(res.list == undefined) {
					
					return;
				}else {
					this.list = res.list;
					this.max_list = res.list.length;
					this.items = [];
					this.count_list = 0;
					for (var i = 0; i < 9; i++) {
						if(this.max_list <= this.count_list) break;
						this.items.push(this.list[this.count_list]);
						this.count_list ++;
					}
					
				}
			} else if(res.result ==="LOGOUT"){
				
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		
		},(err)=>{
			
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

	_items_inf(infiniteScroll) {
        setTimeout(() => {    
            for (var i = 0; i < 9; i++) {
                if(this.max_list <= this.count_list) break;
                this.items.push(this.list[this.count_list]);                
                this.count_list ++;
            } 

            infiniteScroll.complete();
        }, 500);
    }

	_open_notifi_modal(idx) {
		this.navCtrl.push(NotifimodalPage, {idx: idx});
	}
}



// WEBPACK FOOTER //
// ./src/pages/notification/notification.ts